var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('card');
import styled, { css } from 'styled-components';
import { Badge } from './badge';
import { ResponsiveContainer } from './responsive-container';
import { useLink } from '../hooks/use-link';
import { useTheme } from '../hooks/use-theme';
import { get } from 'lodash';
export var CardDefaultProps = {
  onClick: function () {},
  spaceUnits: 6,
  target: '_self',
  linkVariant: 'card'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n    text-decoration: none;\n    height: 100%;\n  "], ["\n    font-family: ", ";\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n    text-decoration: none;\n    height: 100%;\n  "])), theme.FONT('sans'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-decoration: none;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    ", "\n  "], ["\n    text-decoration: none;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    ", "\n  "])), function (props) {
    return props.spaceUnits !== 0 && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(props.spaceUnits));
  })
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    line-height: 1.05em;\n\n    p {\n      line-height: 1.5em;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    line-height: 1.05em;\n\n    p {\n      line-height: 1.5em;\n    }\n  "])))
});
var FooterStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ImageContainer: styled(ResponsiveContainer)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Badge: styled(Badge)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
export var Card = function (props) {
  var className = props.className,
    image = props.image,
    children = props.children,
    target = props.target,
    onClick = props.onClick,
    footer = props.footer,
    spaceUnits = props.spaceUnits,
    imageAspectRatio = props.imageAspectRatio,
    href = props.href,
    linkVariant = props.linkVariant;
  var theme = useTheme();
  var linkStyle = {
    textDecoration: 'none',
    color: get(theme, 'color.text', '#000')
  };
  var _a = useLink(),
    Link = _a.Link,
    navigate = _a.navigate;
  var inner = React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, image && (imageAspectRatio ? React.createElement(My.ImageContainer, {
    aspectRatio: imageAspectRatio
  }, image) : image), React.createElement(My.Body, {
    spaceUnits: spaceUnits
  }, React.createElement(My.Content, null, children), footer && React.createElement(My.Footer, null, footer)));
  return href && linkVariant === 'card' ? React.createElement(Link, {
    target: target,
    style: linkStyle,
    href: href
  }, inner) : inner;
};
Card.defaultProps = CardDefaultProps;
Card.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;